import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from 'components/Icon';
import Dropdown from 'components/Dropdown';
import { now } from 'helpers/DateTimeHelper';
import { OVERLAY_LIVE_CTA_OVERFLOW } from 'helpers/FilterHelper';
import { getVideoData, getVideoTimeData } from 'screens/Live/LiveHelpers';

import dropdownTheme from 'screens/Live/styles/Dropdown.css';
import Style from './PrimeTimeItem.module.scss';

class PrimeTimeItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.toggleOverflowDropdown = this.toggleOverflowDropdown.bind(this);
  }

  toggleOverflowDropdown() {
    const { resetStillWatchingTimeout, setOverlay } = this.props;
    setOverlay(OVERLAY_LIVE_CTA_OVERFLOW);
    resetStillWatchingTimeout();
  }

  renderDetails = ({ subtitle, description, title }) => (
    <div className={Style.detailContainerLeft}>
      <h2 className={Style.detailTitle}>{title}</h2>
      <div className={Style.detailSubtitle}>{subtitle}</div>
      <div className={Style.detailDescription}>{description}</div>
    </div>
  );

  renderItem() {
    const { item, idx, openIdx, date, openIdxDate } = this.props;
    const isOpen = openIdx === idx && openIdxDate === date;

    const { starts } = getVideoTimeData({ video: item, current: now() });
    const { title, subtitle, description } = getVideoData(item);
    const arrow = (
      <Icon color="white" icon={isOpen ? 'keyboard-arrow-up' : 'keyboard-arrow-down'} />
    );

    let detailsElement = (
      <span className={Style.titleContainer}>
        <span className={Style.title}>
          <span className={Style.titleText}>{title}</span>
        </span>
        <span className={Style.subtitle}>{subtitle}</span>
      </span>
    );
    if (isOpen) {
      detailsElement = this.renderDetails({ subtitle, description, title });
    }

    return (
      <div className={Style.container}>
        <span className={Style.timestamp}>{starts}</span>
        {detailsElement}
        <span className={Style.caret}>{arrow}</span>
      </div>
    );
  }

  renderOverflowDropdown(ctaDetails) {
    if (ctaDetails.length < 3) return null;
    const { overlay } = this.props;
    const isOpen = overlay === OVERLAY_LIVE_CTA_OVERFLOW;
    const overflowHoverEffect = isOpen ? null : dropdownTheme.overflowHoverEffect;
    const items = ctaDetails.slice(2);

    return (
      <div
        className={Style.overflowButtonWrapper}
        onClick={() => {
          this.toggleOverflowDropdown();
        }}
      >
        <Dropdown
          theme={dropdownTheme}
          items={items}
          onOpenDropdown={this.toggleOverflowDropdown}
          onCloseDropdown={this.toggleOverflowDropdown}
          displayResults
          showMobileCancel
          expanded={isOpen}
          className={classNames(
            Style.dropdown,
            dropdownTheme.overflowDropdown,
            overflowHoverEffect,
          )}
          getIcon={() => {}}
          defaultText="• • •"
        />
      </div>
    );
  }

  render() {
    const { item, idx, date, overlay, toggleItem } = this.props;
    const { title } = getVideoData(item);
    const { starts, ends } = getVideoTimeData({ video: item, current: now() });
    const hoverTitle = `${title}\n(${starts} - ${ends})`;
    const itemZIndex = overlay === OVERLAY_LIVE_CTA_OVERFLOW ? Style.open : Style.closed;

    return (
      <div
        className={classNames(Style.primeTimeMain, itemZIndex)}
        title={hoverTitle}
        onClick={() => {
          toggleItem(idx, date);
        }}
      >
        {this.renderItem()}
      </div>
    );
  }
}

PrimeTimeItem.defaultProps = {
  favoritesManager: null,
  openIdx: null,
  openIdxDate: null,
  overlay: null,
  resetStillWatchingTimeout: () => {},
  router: {},
  toggleItem: () => {},
};

PrimeTimeItem.propTypes = {
  date: PropTypes.string.isRequired,
  favoritesManager: PropTypes.shape({
    favorites: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    setFavorites: PropTypes.func.isRequired,
    deleteFavorites: PropTypes.func.isRequired,
  }),
  idx: PropTypes.number.isRequired,
  item: PropTypes.shape({}).isRequired,
  openIdx: PropTypes.number,
  openIdxDate: PropTypes.string,
  overlay: PropTypes.string,
  toggleItem: PropTypes.func,
  resetStillWatchingTimeout: PropTypes.func,
  router: PropTypes.shape({
    push: PropTypes.func,
  }),
  setOverlay: PropTypes.func.isRequired,
};

export default withRouter(PrimeTimeItem);
